import { NavigationMenuId } from '../enums/navigationMenuId'

export const isNavigationMenuId = (id: string): id is NavigationMenuId => {
  return Object.values(NavigationMenuId).includes(id as NavigationMenuId)
}
